import ActivityTableSummary from './ActivityTableSummary';

export default ActivityTableSummary;
